import { fromJS } from "immutable";
import * as types from "../constants";
import newCustomers1 from "./template/new_customers1.json";
import finishOrder1 from "./template/finish_order1.json";
import newOrder1 from "./template/new_order1.json";
import newSubscriber from "./template/new_subscriber1.json";
import newSubscriberProd from "./template/new_subscriber_prod.json";

import newCustome1 from "../assets/images/template/new_custome.png";
import imageNewSubscriber from "../assets/images/template/new_subscriber1.png";
import imagefinishOrder2 from "../assets/images/template/finishOrder2.png";
import imageNewOrder2 from "../assets/images/template/new_order2.png";

// const blankTemplate = {
//   "id": -1,
//   "title": `Blank Template`,
//   "image": ``,
//   "description": `Blank / empty content`,
//   "template_type": "all",
//   "template": `{"counters":{"u_column":1,"u_row":1},"body":{"rows":[{"cells":[1],"columns":[{"contents":[],"values":{"backgroundColor":"","padding":"0px","border":{},"_meta":{"htmlID":"u_column_1","htmlClassNames":"u_column"}}}],"values":{"columns":false,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"padding":"0px","hideDesktop":false,"hideMobile":false,"noStackMobile":false,"_meta":{"htmlID":"u_row_1","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"deletable":true}}],"values":{"backgroundColor":"#e7e7e7","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"contentWidth":"500px","fontFamily":{"label":"Arial","value":"arial,helvetica,sans-serif"},"linkStyle":{"body":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"_meta":{"htmlID":"u_body","htmlClassNames":"u_body"}}}}`
// };

const shopEmailEventTemplate = {
  id: -2,
  title: `New review`,
  image: imageNewSubscriber,
  description: `New review`,
  template_type: "newsletters",
  template: JSON.stringify(
    process.env.REACT_APP_ENV === "prod" ? newSubscriberProd : newSubscriber,
  ),
  // "template": `{"counters":{"u_row":9,"u_column":20,"u_content_html":1,"u_content_text":7,"u_content_image":5,"u_content_button":1,"u_content_custom_social":2},"body":{"rows":[{"cells":[1],"columns":[{"contents":[{"type":"text","values":{"containerPadding":"10px","_meta":{"htmlID":"u_content_text_2","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"deletable":true,"color":"#000","textAlign":"left","lineHeight":"140%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"text":"<p style=\\"line-height: 140%; font-size: 14px;\\"><span style=\\"font-family: helvetica, sans-serif;\\">Hi {{customer.first_name}},</span></p>\\n<p style=\\"line-height: 140%; font-size: 14px;\\">&nbsp;</p>\\n<p style=\\"line-height: 140%; font-size: 14px;\\"><span style=\\"font-family: helvetica, sans-serif;\\">I really want to send you a special thanks for visiting {{shop.shop_name}}</span></p>\\n<p style=\\"line-height: 140%; font-size: 14px;\\">&nbsp;</p>\\n<p style=\\"line-height: 140%; font-size: 14px;\\"><span style=\\"font-family: helvetica, sans-serif;\\">I hope you had a great experience on our online store. If you have any problems, you can contact me directly through this email address.</span></p>\\n<p style=\\"line-height: 140%; font-size: 14px;\\">&nbsp;</p>\\n<p style=\\"line-height: 140%; font-size: 14px;\\"><span style=\\"font-family: helvetica, sans-serif;\\">I am always here and ready to answer all your questions. Wish you a good day!</span></p>\\n<p style=\\"line-height: 140%; font-size: 14px;\\">&nbsp;</p>\\n<p style=\\"line-height: 140%; font-size: 14px;\\"><span style=\\"font-family: helvetica, sans-serif;\\">Best regards,</span></p>\\n<p style=\\"line-height: 140%; font-size: 14px;\\"><span style=\\"font-family: helvetica, sans-serif;\\">{{shop.shop_full_name}}</span></p>\\n<p style=\\"line-height: 140%; font-size: 14px;\\"><span style=\\"font-family: helvetica, sans-serif;\\">{{shop.owner_title}}, {{shop.shop_name}}</span></p>"}}],"values":{"_meta":{"htmlID":"u_column_1","htmlClassNames":"u_column"}}}],"values":{"columns":false,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"padding":"10px","hideDesktop":false,"hideMobile":false,"noStackMobile":false,"_meta":{"htmlID":"u_row_1","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"deletable":true}},{"cells":[1,2],"columns":[{"contents":[{"type":"image","values":{"containerPadding":"10px","_meta":{"htmlID":"u_content_image_2","htmlClassNames":"u_content_image"},"selectable":true,"draggable":true,"deletable":true,"src":{"url":"http://saveabandonedbabies.org/wp-content/uploads/2015/08/default.png","width":100,"height":98},"textAlign":"center","altText":"Image","action":{"name":"web","values":{"href":"","target":"_blank"},"url":"","target":""},"fullWidth":false,"maxWidth":"100%"}},{"type":"text","values":{"containerPadding":"10px","_meta":{"htmlID":"u_content_text_7","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"deletable":true,"color":"#000","textAlign":"left","lineHeight":"140%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"text":"<p style=\\"font-size: 14px; line-height: 140%; text-align: center;\\"><span style=\\"color: #3366ff; font-size: 14px; line-height: 19.6px; font-family: helvetica, sans-serif;\\"><strong>{{shop.shop_name}}</strong></span></p>\\n<p style=\\"font-size: 14px; line-height: 140%; text-align: center;\\">&nbsp;</p>"}}],"values":{"_meta":{"htmlID":"u_column_11","htmlClassNames":"u_column"}}},{"contents":[{"type":"text","values":{"containerPadding":"10px","_meta":{"htmlID":"u_content_text_3","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"deletable":true,"color":"#000","textAlign":"left","lineHeight":"140%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"text":"<p style=\\"font-size: 14px; line-height: 140%;\\"><span style=\\"font-family: helvetica, sans-serif; font-size: 14px; line-height: 19.6px;\\">Phone: {{shop.phone_number}}</span></p>\\n<p style=\\"font-size: 14px; line-height: 140%;\\"><span style=\\"font-family: helvetica, sans-serif; font-size: 14px; line-height: 19.6px;\\">Email: {{shop.email}}</span></p>\\n<p style=\\"font-size: 14px; line-height: 140%;\\"><span style=\\"font-family: helvetica, sans-serif; font-size: 14px; line-height: 19.6px;\\">Website: <a href=\\"https://{{shop.website}}\\">{{shop.website}}</a></span></p>\\n<p style=\\"font-size: 14px; line-height: 140%;\\"><span style=\\"font-family: helvetica, sans-serif; font-size: 14px; line-height: 19.6px;\\">Address: {{shop.address}}</span></p>"}}],"values":{"_meta":{"htmlID":"u_column_12","htmlClassNames":"u_column"}}}],"values":{"columns":false,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"padding":"10px","hideDesktop":false,"hideMobile":false,"noStackMobile":false,"_meta":{"htmlID":"u_row_5","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"deletable":true}}],"values":{"backgroundColor":"#ffffff","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"contentWidth":"650px","fontFamily":{"label":"Arial","value":"arial,helvetica,sans-serif"},"linkStyle":{"body":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"_meta":{"htmlID":"u_body","htmlClassNames":"u_body"}}}}`
};

const shopEmailNewCustomersTemplate = {
  id: -3,
  title: `New customers`,
  image: newCustome1,
  description: `New customers`,
  template_type: "new_customers",
  template: JSON.stringify(newCustomers1),
};
const shopEmailFinishOrderTemplate1 = {
  id: -4,
  title: `Fulfilled order Template`,
  image: imagefinishOrder2,
  description: `Fulfilled orders`,
  template_type: "finish_order",
  template: JSON.stringify(finishOrder1),
};
const shopEmailNewOrder1Template1 = {
  id: -5,
  title: `New order Template`,
  image: imageNewOrder2,
  description: `New orders`,
  template_type: "new_order",
  template: JSON.stringify(newOrder1),
};

const defaultListTemplate = [
  shopEmailNewCustomersTemplate,
  shopEmailEventTemplate,
  shopEmailFinishOrderTemplate1,
  shopEmailNewOrder1Template1,
];

const defaultState = fromJS({
  templates: defaultListTemplate,
  formData: null,
  onActiveFormReview: false,
  onActiveFormReviewComment: false,
  onActiveFormReviewOrder: false,
  shopInfo: null,
  sendTest: null,
  isSaveCampaign: false,
  onLoadData: false,
  onSendTestEmail: false,
  campaignName: "",
  listEmailVerify: [],
});

const campaignReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.GET_CAMPAIGN_NAME:
      return state.set("campaignName", action.payload);

    case types.RESULT_GET_SETTING_SHOP_INFO:
      return state.set("shopInfo", action.payload);

    case types.CHANGE_ON_LOAD_DATA:
      return state.set("onLoadData", false);

    case types.GET_FORM_EMAIL_REVIEW_RESULT:
      return state
        .set("formData", action.payload)
        .set("onActiveFormReview", action.payload.on_off_sendmail)
        .set("onLoadData", true);

    case types.GET_FORM_EMAIL_REVIEW_COMMENT_RESULT:
      return state
        .set("formData", action.payload)
        .set("onActiveFormReviewComment", action.payload.on_off_sendmail)
        .set("onLoadData", true);

    case types.GET_FORM_EMAIL_REVIEW_ORDER_RESULT:
      return state
        .set("formData", action.payload)
        .set("onActiveFormReviewComment", action.payload.on_off_sendmail)
        .set("onLoadData", true);

    case types.GET_STATUS_FORM_EMAIL_REVIEW_RESULT:
      return state.set("onActiveFormReview", action.payload);

    case types.GET_STATUS_FORM_EMAIL_REVIEW_COMMENT_RESULT:
      return state.set("onActiveFormReviewComment", action.payload);

    case types.GET_STATUS_FORM_EMAIL_REVIEW_ORDER_RESULT:
      return state.set("onActiveFormReviewOrder", action.payload);

    case types.CHANGE_ACTIVE_FORM_REVIEW:
      return state.set("onActiveFormReview", action.on_off_sendmail);

    case types.CHANGE_ACTIVE_FORM_REVIEW_COMMENT:
      return state.set("onActiveFormReviewComment", action.on_off_sendmail);

    case types.CHANGE_ACTIVE_FORM_REVIEW_ORDER:
      return state.set("onActiveFormReviewOrder", action.on_off_sendmail);

    case types.RESULT_SAVE_CAMPAIGN:
      return state.set("isSaveCampaign", action.payload);

    case types.SEND_TEST_EMAIL_RESULT:
      return state.set("onSendTestEmail", action.payload);

    case types.RESET_IS_SAVE_CAMPAIN:
      return state.set("isSaveCampaign", false);

    case types.RESET_SEND_TEST_EMAIL:
      return state.set("onSendTestEmail", false);

    case types.GET_LIST_EMAIL_VERIFY_RESULT:
      return state.set("listEmailVerify", action.payload);

    default:
      return state;
  }
};

export default campaignReducer;
